<template>
  <sc-page-base
    :title="title"
    :loading="loading">
    <sc-form
      ref="form"
      :form="form"
      :rules="rules"
      :hasStyle="false"
      :buttonsStyle="false"
      @submit="onGetPreInvoices">
      <template slot="fields" slot-scope="{ fields, isValid }">
        <div class="columns">
          <div class="column page-container">
            <sc-pre-invoice-generation-form
              :fields="fields"
              :is-valid="isValid"
              :loading-exports="loadingExports"
              @clearFilters="clearFilters"
              @exportToExcel="onExportToExcel" />

            <sc-pre-invoice-generation-table
              v-if="invoices.length > 0 && !loading"
              :form="form"
              :invoices="invoices"
              @generatePreInvoice="onSendPreInvoice" />
          </div>
        </div>
      </template>
    </sc-form>
  </sc-page-base>
</template>

<script>
import { ScPageBase, ScForm, ScToast } from '@intelipost-js/secure-components';
import { createNamespacedHelpers } from 'vuex';

import ScPreInvoiceGenerationForm from './components/sc-pre-invoice-generation-form/ScPreInvoiceGenerationForm';
import ScPreInvoiceGenerationTable from './components/sc-pre-invoice-generation-table/ScPreInvoiceGenerationTable';

const {
  mapState,
  mapActions,
} = createNamespacedHelpers('recon/preInvoiceGeneration');

export default {
  name: 'page-pre-invoice-generation',
  data() {
    return {
      title: 'Geração de Pré Fatura',
    };
  },
  computed: {
    ...mapState([
      'form',
      'invoices',
      'loading',
      'loadingExports',
    ]),
    rules() {
      return {
        warehouses: [
          {
            required: true,
            message: 'Selecione pelo menos um Centro de Distribuição',
          },
        ],
        date_range: [
          {
            required: true,
            message: 'Selecione uma data',
          },
        ],
      };
    },
  },
  methods: {
    ...mapActions([
      'getPreInvoices',
      'sendPreInvoice',
      'exportToExcel',
    ]),
    clearFilters() {
      this.$refs.form.clearFilters();
    },
    onGetPreInvoices(filters) {
      this.$store.commit('recon/preInvoiceGeneration/setForm', filters);
      this.getPreInvoices(filters).then((preInvoices = []) => {
        if (Array.isArray(preInvoices) && preInvoices.length === 0) {
          ScToast.danger('Nenhuma nota fiscal disponível para conciliação');
        }
      });
    },
    onExportToExcel(filters) {
      this.exportToExcel(filters).then(() =>
        ScToast.success('O relatório está sendo gerado, assim que finalizado estará disponível na seção Meus Arquivos.'),
      );
    },
    onSendPreInvoice(invoices) {
      this.sendPreInvoice(invoices)
        .then(({ createPreInvoices }) => {
          const { ok = true } = createPreInvoices || {};

          if (ok) {
            ScToast.success('Geração de Pré-Fatura solicitada. Por favor aguarde a finalização do processo.');
            this.$refs.form.submit();
          }
        })
        .catch(() => ScToast.danger('Erro ao gerar pré-fatura'));
    },
  },
  components: {
    ScPageBase,
    ScForm,
    ScPreInvoiceGenerationForm,
    ScPreInvoiceGenerationTable,
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/pre-invoice-generation/PagePreInvoiceGeneration.vue?3f3bbe80